import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { Box, Icon, Text } from '@sparknz/spark-pattern-library';

import Clickable from 'shared/components/Clickable';
import { INFORMATION_ICON_TEXT } from '../constants/planCard.constant';

const ConditionsText = styled(Text)`
  ${({ theme: { spacing } }) => css`
    margin-right: ${spacing.s1};
  `}
`;

const ConditionsWrapper = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

const VIEW_KEY_CONDITIONS_TEXT = 'View key conditions';

interface PlanCardKeyConditionSectionProps {
  handleKeyConditionsClick?: (customLink: string) => void;
}

const PlanCardKeyConditionSection = ({
  handleKeyConditionsClick,
}: PlanCardKeyConditionSectionProps) => {
  const {
    palette: { baseColors },
  } = useTheme();
  return (
    <Box flexDirection="row" pt="s2" mb="s2" mx="s4">
      <ConditionsText variant="bodySDemi">{`*${VIEW_KEY_CONDITIONS_TEXT}`}</ConditionsText>

      <ConditionsWrapper>
        <Clickable
          aria-label="key conditions icon"
          title="key conditions icon"
          onClick={() =>
            handleKeyConditionsClick(
              `${VIEW_KEY_CONDITIONS_TEXT} ${INFORMATION_ICON_TEXT}`,
            )
          }
        >
          <Icon name="info_small" fill={baseColors.lupin} />
        </Clickable>
      </ConditionsWrapper>
    </Box>
  );
};

export default PlanCardKeyConditionSection;
